export type PositionValue =
  | "portero"
  | "defensa_central"
  | "lateral_derecho"
  | "lateral_izquierdo"
  | "mediocampista_central"
  | "mediocampista_ofensivo"
  | "mediocampista_defensivo"
  | "extremo_derecho"
  | "extremo_izquierdo"
  | "delantero_centro"
  | "segundo_delantero"

export interface PositionOption {
  value: PositionValue
  label: string
}

export const POSITIONS: PositionOption[] = [
  { value: "portero", label: "Portero" },
  { value: "defensa_central", label: "Defensa Central" },
  { value: "lateral_derecho", label: "Lateral Derecho" },
  { value: "lateral_izquierdo", label: "Lateral Izquierdo" },
  { value: "mediocampista_central", label: "Mediocampista Central" },
  { value: "mediocampista_ofensivo", label: "Mediocampista Ofensivo" },
  { value: "mediocampista_defensivo", label: "Mediocampista Defensivo" },
  { value: "extremo_derecho", label: "Extremo Derecho" },
  { value: "extremo_izquierdo", label: "Extremo Izquierdo" },
  { value: "delantero_centro", label: "Delantero Centro" },
  { value: "segundo_delantero", label: "Segundo Delantero" },
]

export const POSITION_LABELS: Record<PositionValue, string> =
  Object.fromEntries(POSITIONS.map((p) => [p.value, p.label])) as Record<
    PositionValue,
    string
  >
